import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function ProductCategory() {
  const { category } = useParams();
  return (
    <>
      <Helmet><title>{category} | Cool Wave</title></Helmet>
      <section className="container py-16">
        <h1 className="mb-2 text-3xl font-bold capitalize">{category}</h1>
        <p className="text-body">Products will appear here once the catalogue is live.</p>
      </section>
    </>
  );
}
